/**
 * `/cycles/:cycleId/forecast` (f11.3). With `?bu=` it is f11.1's grid,
 * unchanged. Without it, the caller goes -- as a history REPLACE -- to the
 * first unit the server lists in their rail entry, or sees "Nothing to input".
 */

import { Navigate, useParams, useSearchParams } from 'react-router-dom';

import { useInputEntry } from '@/api/queries';
import { NothingToInput } from '@/routes/cycles/ScopedCycleWorkspace';
import { RecordUnavailable } from '@/ui/RecordUnavailable';

import { ForecastGridPage } from './ForecastGridPage';

export function ForecastEntryRedirect() {
  const { cycleId = '' } = useParams();
  const [params] = useSearchParams();
  const bu = params.get('bu');
  const input = useInputEntry(bu ? undefined : cycleId);

  if (bu) return <ForecastGridPage />;
  if (input.error) {
    return (
      <RecordUnavailable
        error={input.error}
        backTo="/cycles"
        backLabel="Cycles"
        onRetry={() => void input.refetch()}
      />
    );
  }
  if (!input.data) return null;

  const target = input.data.entry.default_business_unit_id;
  if (!target) return <NothingToInput code={input.data.cycle.code} />;
  return (
    <Navigate
      replace
      to={`/cycles/${encodeURIComponent(cycleId)}/forecast?bu=${encodeURIComponent(target)}`}
    />
  );
}
